import { Card, Stack, styled, Typography } from "@mui/material"
import { ClaimDTO, GetPublicClaimDetailResponse } from "../../../client/motalvip-apis/generated"
import { ClaimStatusColorMapping, ClaimStatusNameMapping } from "../constants"
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot'
import { HistoryItem } from "./HistoryItem";

const TimelineWrapper = styled("div")({
    '& .MuiTimeline-root': {
        padding: '0px',
    },
    '& .MuiTimelineItem-root': {
        '&::before': {
            padding: '0px',
        }
    }
})

interface Props {
    claimDetail: GetPublicClaimDetailResponse
}

export const ClaimStatusHistoryCard = ({ claimDetail }: Props) => {
    const statusHistory = claimDetail.statusHistory || []

    const lastStatus = statusHistory[statusHistory.length - 1]?.status

    return (
        <Card sx={{ padding: { xs: "16px", md: "38px" }, overflow: 'visible' }}>
            <Typography fontSize={{ xs: "16px", md: "22px" }} fontWeight={400} color="#292929">สถานะการซ่อมปัจจุบัน</Typography>
            <Typography mt="10px" mb={{ xs: "10px", md: "24px" }} fontSize={{ xs: "36px", md: "40px" }} fontWeight={600} color={ClaimStatusColorMapping[lastStatus || ClaimDTO.status.NONE]}>{ClaimStatusNameMapping[lastStatus || ClaimDTO.status.NONE]}</Typography>
            <Stack direction="column">
                <TimelineWrapper>
                    <Timeline>
                        {statusHistory?.map((item, index) => {
                            return (
                                <TimelineItem key={index} position="right">
                                    <TimelineSeparator>
                                        <TimelineDot />
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                        <HistoryItem status={item.status!} createdAt={item.createdAt!} />
                                    </TimelineContent>
                                </TimelineItem>
                            )
                        })}
                    </Timeline>
                </TimelineWrapper>
            </Stack>
        </Card>
    )
}